import { render, staticRenderFns } from "./ClientAppDetail.vue?vue&type=template&id=2d4dcfb0&scoped=true"
import script from "./ClientAppDetail.vue?vue&type=script&lang=js"
export * from "./ClientAppDetail.vue?vue&type=script&lang=js"
import style0 from "./ClientAppDetail.vue?vue&type=style&index=0&id=2d4dcfb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4dcfb0",
  null
  
)

export default component.exports